import React from 'react';
import Datatable from '../../../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import * as RegistrationDetailSelector from '../../../../../../redux/reducers/registration_detail_reducer/selectors';

interface IProps {
  mode: 'VIEW' | 'EDIT';
}

export default function IdentificationInOtherEuCountriesTable(props: IProps) {
  const result = RegistrationDetailSelector.useGetIdentificationInOtherEuCountries();
  return (
    <Datatable
      loading={true}
      paging={undefined}
      data={result}
      columns={TableColumns(props.mode)}
    />
  );
}
